var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#959598",
    strokeWidth: 0.8,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1a9.253 9.253 0 0 1 4.89 1.385c3.8 2.357 4.08 7.224 1.051 10.782A45.564 45.564 0 0 1 9 19a45.564 45.564 0 0 1-5.942-5.833C.031 9.61.311 4.742 4.11 2.385A9.253 9.253 0 0 1 9 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.96V7.265a.791.791 0 0 0-.8-.783h-.8M7.4 11.96h3.2M9 4.526c.11 0 .2.087.2.195M8.8 4.721c0-.108.09-.195.2-.195M9 4.917c-.11 0-.2-.088-.2-.196M9.2 4.721c0 .108-.09.196-.2.196"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfo);
export default __webpack_public_path__ + "static/media/more-info.36a59018cab0a0d633600ef44664d6b4.svg";
export { ForwardRef as ReactComponent };